import dash from '../img/dashed.png'



// import Modal from 'react-bootstrap/Modal';
import { useState } from 'react'
import BackArray from '../Arrays/BackgroundArray';



const Background = () => {
    

    const [modalShow, setModalShow] = useState(false);
    const [imgVal, setImgVal] = useState("");
    const [caption, setCaption] = useState("");
    const [currentIndex, setCurrentIndex] = useState(0);

    const imgArry = BackArray.map((media) => media.img);


    const closeModal = () => {
        setModalShow(false);
        setImgVal("");
        setCaption("");
    };

    const prevImg = () => {
        const newIndex = (currentIndex - 1 + imgArry.length) % imgArry.length;
        setCurrentIndex(newIndex);
        setImgVal(imgArry[newIndex]);
    };

    const nextImg = () => {
        const newIndex = (currentIndex + 1) % imgArry.length;
        setCurrentIndex(newIndex);
        setImgVal(imgArry[newIndex]);
    };

    const ImgElement = (props) => {
        return (
            <>
                <span className={`${props.position} cursor-pointer`} >
                    <img src={props.img} alt='' className="media" onClick={() => { setModalShow(true); setImgVal(props.img) }} />
                </span>
            </>
        )
    }

    return (
        <>
            <div className="container mt-5" id="Background">
                <div className="row">
                    <div className="col-md-12 text-center mt-5">
                        <h2 className="Headers mb-0 fs-lg-3 fs-md-3 fs-sm-2">Cricketer Background & Career</h2>
                        <img src={dash} className="mx-auto" alt="" />
                    </div>
                    <div className="col-md-7 my-auto">
                        <p className="text-justify back-paragraph">People with disabilities are one of the most invisible communities in India. Due to their disability & mobility barriers, they do not go outside of their houses much. Wheelchair Cricket gives them an opportunity to come out & express themselves. Currently there are 25 persons with disabilities in Mumbai,practising & participating in cricket matches. We are aiming to increase that number to 50-60 persons with disabilities within 2 years. </p>
                        <p className="text-justify back-paragraph"> Wheelchair Cricketers are players with different disabilities like polio,amputation, spinal cord injury & cerebral palsy. Due to the current lack of financial resources, cricket cannot serve as their primary source of income, therefore, they also work. Some players are delivery boys, bike mechanics, mixer mechanics, auto drivers & some run their small shops and other micro businesses. However, this does not stop them from playing & practicing regularly. They carry their wheelchairs & cricket kits on their modified Activas & few of them also travel by train & bus to practice, in spite of the fact that public transport is not wheelchair accessible.</p>
                        <p className="text-justify back-paragraph">
                            Currently, Wheelchair Cricketers are playing this sport as their passion. Cricket is not their prime source of income, they have to work elsewhere. We need proper guidance, professional training & strong financial support, so that players can only focus on their practice & performance. We also want players to take up Wheelchair Cricket as their career so that they can get match fees, daily allowance & travelling allowance. We are trying to create a full eco-system for betterment of Wheelchair Cricket in Mumbai.
                        </p>
                    </div>
                    <div className="col-md-5 my-auto" >
                        <div className="media-container">
                            {/* <MyVerticallyCenteredModal show={modalShow} onHide={() => setModalShow(false)} img={imgVal} size={imgsize} /> */}
                            {BackArray.map((value, index) => {
                                return (
                                    <ImgElement img={value.img} key={index} size={value.size} position={value.position} />
                                )
                            })}

                            {modalShow && (
                                <div
                                    className="custom-modal-overlay"
                                    style={{
                                        position: "fixed",
                                        top: 0,
                                        left: 0,
                                        width: "100vw",
                                        height: "100vh",
                                        backgroundColor: "rgba(0,0,0,0.9)",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        zIndex: 9999,
                                    }}
                                >
                                    {/* Close Button */}
                                    <span
                                        onClick={closeModal}
                                        style={{
                                            position: "absolute",
                                            top: "20px",
                                            right: "30px",
                                            color: "#fff",
                                            fontSize: "30px",
                                            fontWeight: "bold",
                                            cursor: "pointer",
                                            zIndex: 1000,
                                        }}
                                    >
                                        &times;
                                    </span>

                                    {/* Prev Button */}
                                    <button
                                        onClick={prevImg}
                                        style={{
                                            position: "absolute",
                                            top: "50%",
                                            left: "20px",
                                            transform: "translateY(-50%)",
                                            fontSize: "2rem",
                                            color: "#fff",
                                            background: "none",
                                            border: "none",
                                            cursor: "pointer",
                                        }}
                                    >
                                        &#10094;
                                    </button>

                                    {/* Image */}
                                    <img
                                        src={imgVal}
                                        alt=""
                                        style={{
                                            maxWidth: "90vw",
                                            maxHeight: "90vh",
                                            objectFit: "contain",
                                            boxShadow: "0 0 20px #000",
                                        }}
                                    />

                                    {/* Next Button */}
                                    <button
                                        onClick={nextImg}
                                        style={{
                                            position: "absolute",
                                            top: "50%",
                                            right: "20px",
                                            transform: "translateY(-50%)",
                                            fontSize: "2rem",
                                            color: "#fff",
                                            background: "none",
                                            border: "none",
                                            cursor: "pointer",
                                        }}
                                    >
                                        &#10095;
                                    </button>

                                    {/* Caption */}
                                    {caption && (
                                        <div
                                            style={{
                                                position: "absolute",
                                                bottom: "20px",
                                                color: "#fff",
                                                textAlign: "center",
                                                width: "100%",
                                            }}
                                        >
                                            {caption}
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>

                </div>
            </div>

        </>
    )
}

export default Background;





